export default __webpack_public_path__ + "images/0xb1e25689d55734fd3fffc939c4c3eb52dff8a794.png";